import type { Editor } from "@tiptap/core";
import { useRef, useSyncExternalStore } from "react";
import { type BlockToolbarEntry, getBlockToolbarRegistry } from "./BlockToolbarRegistry";

interface BlockActionsGroupProps {
	editor: Editor;
	pos: number;
	asGroup?: boolean;
}

// A deleted node unregisters at once, while the toolbar still plays its hide animation over these actions.
const useLastEntryAt = (editor: Editor, pos: number) => {
	const registry = getBlockToolbarRegistry(editor);
	useSyncExternalStore(registry.subscribe, registry.getSnapshot, registry.getSnapshot);
	const last = useRef<{ pos: number; entry: BlockToolbarEntry }>(null);

	const entry = registry.at(pos);
	if (entry) last.current = { pos, entry };
	return entry ?? (last.current?.pos === pos ? last.current.entry : undefined);
};

export const BlockActionsGroup = ({ editor, pos, asGroup }: BlockActionsGroupProps) => {
	const entry = useLastEntryAt(editor, pos);
	return asGroup ? entry?.groupActions : entry?.actions;
};
